/**
 * services.ts
 * ----------------
 * Utility functions for severities.
 */

import { LiveSiteEventSeverity } from '../models/status';

/**
 * Gets standardized string representation of a severity. Primarily used to coerce case-insensitive
 * equivalents into the proper casing.
 * @param value Value to check
 * @returns Normalized severity if it is a valid value, undefined otherwise
 */
export function getNormalizedSeverity (value: string): LiveSiteEventSeverity | undefined {
    if (value.toLowerCase() === 'Advisory'.toLowerCase()) {
        return 'Advisory';
    }

    if (value.toLowerCase() === 'Degraded'.toLowerCase()) {
        return 'Degraded';
    }

    if (value.toLowerCase() === 'Unhealthy'.toLowerCase()) {
        return 'Unhealthy';
    }

    return undefined;
}

/**
 * Checks whether or not the given string value is a valid severity.
 * @param value Value to check
 * @param ignoreCase Whether or not check should ignore case. Default is false.
 * @returns Whether or not passed value is a valid severity
 */
export function isValidSeverity (value: string, ignoreCase = false) {
    const compareValue = ignoreCase ? value.toLowerCase() : value;

    return compareValue === (ignoreCase ? 'Advisory'.toLowerCase() : 'Advisory')
        || compareValue === (ignoreCase ? 'Degraded'.toLowerCase() : 'Degraded')
        || compareValue === (ignoreCase ? 'Unhealthy'.toLowerCase() : 'Unhealthy');
}
